<template>
  <div class="pages_content">
    <div class="imgcenter">
      <img src="@/assets/BASEindex.png" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.imgcenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

